import React from 'react'
import { Modal, Button, Spin } from 'antd'
import { Link } from 'react-router-dom'

const AdminBoxNoSelect = ({
  isOpen,
  selectedRack,
  boxList,
  onClose,
  id,
  loading,
}) => {
  return (
    <Modal
      title={`Rack: ${selectedRack}`}
      open={isOpen}
      onCancel={onClose}
      footer={
        <div className='mt-4'>
          <button type='button' className='btn btn-secondary' onClick={onClose}>
            Close
          </button>
        </div>
      }
      // Fixed 800px overflowed the viewport on a handheld.
      width='90%'
      style={{ maxWidth: 800 }}
    >
      {loading ? (
        <div className='text-center py-4'>
          <Spin size='large' />
        </div>
      ) : boxList.length > 0 ? (
        // .box-grid was never defined in any stylesheet, so the boxes just
        // flowed inline. Grid here so they wrap evenly at any width.
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.85rem',
          }}
        >
          {boxList.map((box, index) => (
            <Link
              key={index}
              to={`/admin/stock-check/store-room/${selectedRack}/${
                box.boxNo || 'empty'
              }/${id}`}
            >
              <Button
                style={{
                  fontSize: '16px',
                  height: '44px',
                  minWidth: '90px',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                  backgroundColor: box.boxStatus === 1 ? '#0d6efd' : 'initial',
                  color: box.boxStatus === 1 ? 'white' : 'black',
                }}
              >
                {box.boxNo || ''}
              </Button>
            </Link>
          ))}
        </div>
      ) : (
        <div className='text-muted'>No boxes found for this rack.</div>
      )}
    </Modal>
  )
}

export default AdminBoxNoSelect
